import { VideoSubtitleType } from 'type/videoSubtitleType';

export interface StreamManifest {
  id?: number;
  type: string;
  preset: string;
  stream_url: string;
  stream_url_full?: string;
  signed_url?: string;
  status: string;
  created: string;
  modified?: string;
}

export interface VideoAssetSet {
  id?: number;
  content: number;
  video: number | null;
  video_name?: string;
  subtitle_ids?: number[] | null;
  subtitles?: VideoSubtitleType[] | null;
  is_subtitles_embedded: boolean;
  is_default: boolean;
  service_name: string;
  isNew?: boolean;
  stream_manifests: StreamManifest[] | null;
  tempId?: number;
  after_add_subtitle?: boolean;
}

export interface ContentVideoAssetHistory {
  id: number;
  content: number;
  user: string;
  action: string;
  status: string;
  extra_info?: any;
  created?: string;
}

export interface VideoSearchParams {
  search?: string;
  source?: string;
  status?: string;
  page?: number;
  pageSize?: number;
}

export interface VideoSearchResult {
  data: any[];
  count: number;
}

export interface StatusDisplay {
  color: string;
  label: string;
}

export const SERVICE_OPTIONS = ['odk', 'odc', 'amasian'] as const;

export type ServiceOption = (typeof SERVICE_OPTIONS)[number];
